import React from "react";

import svg from "../../assets/images/icons/step_description.svg";

export const StepDescriptionIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Description"}
    />
);
